import { defineComponent as _defineComponent } from 'vue'
import { inject, Ref, ref } from 'vue';
import { Icons } from '@/font-awesome';
import CommonButton from '../CommonButton.vue';
import { WhatsappUtils } from '@/utils/whatsapp_utils';
import Constants from '@/infra/constants/constants';
import { AdminUser } from '@/models/admins/admin_model';
import { useTwoFactorAuthStore } from '@/stores/two_factor_auth/two_factor_auth_store';
import { AlertModalInjectionV2, LoadingModalInjection, TwoFactorAuthModalInjection } from '@/infra/constants/injections';
import LoadingModal from '../modals/LoadingModal.vue';
import AlertModalV2 from '../modals/AlertModalV2.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import TwoFactorAuthModal from './TwoFactorAuthModal.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CodeTwoFactorContent',
  props: {
    currentPage: { type: Number, required: true },
    adminUser: { type: Object, required: true },
    qrCodeUrl: { type: String, required: true },
    secret: { type: String, required: true }
  },
  emits: ["on-code-input-change", "change-page"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const codeInputs = ref<string[]>(Array(6).fill(''));
const inputRefs = ref<Array<HTMLInputElement | null>>([]);
const maxLength = ref<number>(1);
const store = useTwoFactorAuthStore();
const errorText = ref<string | null>(null);
const loadingModal = inject<Ref<InstanceType<typeof LoadingModal>> | null>(LoadingModalInjection);
const alertModalV2 = inject<Ref<InstanceType<typeof AlertModalV2>>>(AlertModalInjectionV2);
const fixedIcon = Icons.imported.faCircleExclamation;
const twoFactorAuthModal = inject<Ref<InstanceType<typeof TwoFactorAuthModal>> | null>(TwoFactorAuthModalInjection);

const props = __props;

const emit = __emit;

async function validateCode() {
  try {
    loadingModal?.value?.open({ zIndex: 10000 } );
    const res = await store.submit();

    if (res.isError()) {
      alertModalV2?.value?.open({
        zIndex: 10000,
        title: 'Código Inválido',
        size: 'medium',
        icon: fixedIcon,
        modalType: 'error',
        content: res.getError() ?? 'Erro desconhecido'
      });
      return;
    }
    
    emit('change-page', props.currentPage + 1);
  } finally {
    loadingModal?.value?.close();
  }
}

function handlePaste(event: ClipboardEvent) {
  event.preventDefault();
  const pastedData = event.clipboardData?.getData('text') || '';
  const codeCharacters = pastedData.split('').slice(0, 6);
  codeCharacters.forEach((character, index) => {
    if (index < codeInputs.value.length) codeInputs.value[index] = character;
  });

  emit('on-code-input-change', codeInputs.value.join(''));
}

function handleKeyboardEvent(event: KeyboardEvent, index: number) {
  if (event.key === 'Backspace') {
    event.preventDefault();
    if (codeInputs.value[index] === '') {
      if (index > 0) inputRefs.value[index - 1]?.focus();
      codeInputs.value[index - 1] = '';
    }
    codeInputs.value[index] = '';
    emit('on-code-input-change', codeInputs.value.join(''));
  }
}

function handleInput(event: Event, index: number) {
  let inputValue = (event.target as HTMLInputElement).value;
  inputValue = inputValue.replace(/\D/g, '');
  if (inputValue.length > 1) codeInputs.value[index] = inputValue.charAt(0);
  else codeInputs.value[index] = inputValue;
  if (index < codeInputs.value.length - 1 && inputValue.length === 1) inputRefs.value[index + 1]?.focus();
}

function backButton() {
  const hasTwoFactorKey = props.adminUser.getHasTwoFactorKey();
  if (!hasTwoFactorKey) {
    return emit('change-page', props.currentPage - 1);
  }
  const twoFactorAuthModalInstance = twoFactorAuthModal?.value;
  if (twoFactorAuthModalInstance) {
    twoFactorAuthModalInstance.close();
  }
}


const __returned__ = { codeInputs, inputRefs, maxLength, store, errorText, loadingModal, alertModalV2, fixedIcon, twoFactorAuthModal, props, emit, validateCode, handlePaste, handleKeyboardEvent, handleInput, backButton, get Icons() { return Icons }, CommonButton, get WhatsappUtils() { return WhatsappUtils }, get Constants() { return Constants }, get FontAwesomeIcon() { return FontAwesomeIcon } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})